<div *ngIf="menu == 0">
    <app-menu></app-menu>
</div>
<div *ngIf="menu == 1">
    <app-simulado></app-simulado>
</div>